module.exports = "/img/_/_/_/assets/images/creeper/battle/rare//4.jpg?bebcae79b92122b5b9f1e238af59f319";